export default "__VITE_ASSET__CY2f59Gk__"